export default __webpack_public_path__ + "static/media/8.f6ff42c4.webp";